module.exports = __webpack_public_path__ + "static/media/decoracao_03.7fe8d931.jpg";